var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1707_916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9976 1.33338H11.9976V4.57764e-05H10.6642V1.33338H5.3309V4.57764e-05H3.99756V1.33338H1.99756C1.46713 1.33338 0.958419 1.54409 0.583346 1.91917C0.208272 2.29424 -0.00244141 2.80295 -0.00244141 3.33338L-0.00244141 16.0001H15.9976V3.33338C15.9976 2.80295 15.7869 2.29424 15.4118 1.91917C15.0367 1.54409 14.528 1.33338 13.9976 1.33338ZM1.33089 3.33338C1.33089 3.15657 1.40113 2.987 1.52616 2.86198C1.65118 2.73695 1.82075 2.66671 1.99756 2.66671H13.9976C14.1744 2.66671 14.344 2.73695 14.469 2.86198C14.594 2.987 14.6642 3.15657 14.6642 3.33338V5.33338H1.33089V3.33338ZM1.33089 14.6667V6.66672H14.6642V14.6667H1.33089Z",
    fill: "#26ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 8.66689H10V10.0002H11.3333V8.66689Z",
    fill: "#26ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66439 8.66664H7.33105V9.99998H8.66439V8.66664Z",
    fill: "#26ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9974 8.66689H4.66406V10.0002H5.9974V8.66689Z",
    fill: "#26ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 11.3336H10V12.6669H11.3333V11.3336Z",
    fill: "#26ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66439 11.3334H7.33105V12.6667H8.66439V11.3334Z",
    fill: "#26ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9974 11.3336H4.66406V12.667H5.9974V11.3336Z",
    fill: "#26ABB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1707_916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.f70a63f579c43dfddecf436d79b99ee4.svg";
export { ForwardRef as ReactComponent };